import type { RouteRecordRaw } from 'vue-router'

export const PaymentRoutes: Array<RouteRecordRaw> = [
  {
    path: '/classes/payment-result',
    name: 'class-payment-return',
    meta: { requiresAuth: false },
    component: () => import('@/views/payment/class-payment-return.vue')
  },
  {
    path: '/payment',
    name: 'payment',
    meta: { requiresAuth: false },
    component: () => import('@/views/payment/direct-payment.vue')
  },
  {
    path: '/purchaseVerify',
    name: 'purchase_verify',
    meta: { requiresAuth: false },
    component: () => import('@/views/payment/purchase-verify.vue')
  },
  {
    path: '/buy-plan',
    name: 'buy-subscription',
    meta: { requiresAuth: false },
    component: () => import('@/views/payment/buy-plan.vue')
  },
  {
    path: '/payment-plan',
    name: 'payment-plan',
    meta: { requiresAuth: false },
    component: () => import('@/views/payment/payment-plan.vue')
  },
  {
    path: '/debit-payment',
    name: 'debit-payment',
    meta: { requiresAuth: false },
    component: () => import('@/views/payment/debit-payment.vue')
  },
  {
    path: '/directDebitVerify/:platformType',
    name: 'direct_debit_verification',
    meta: { requiresAuth: false },
    component: () => import('@/views/payment/direct-debit-verification.vue')
  }
]
